(function () {
  const MIN_PARAM = 'filter.p.m.custom.min_hoejde';
  const MAX_PARAM = 'filter.p.m.custom.max_hoejde';
  const PRODUCT_TYPE_PARAM = 'filter.p.product_type';
  const GRAVEL_PRODUCT_TYPES = ['Gravel', 'Gravel cykel', 'Gravelcykel', 'Grusracercykel'];
  const HEIGHT_PARAM = 'height';
  const NO_MATCH_PARAM = 'b4s_size_no_match';
  const LEGACY_MIN_PARAM = 'filter.p.m.custom.min_hoejde.lte';
  const LEGACY_MAX_PARAM = 'filter.p.m.custom.max_hoejde.gte';
  const MIN_HEIGHT = 100;
  const MAX_HEIGHT = 220;
  let debounceTimer;
  let refreshTimer;
  let nativeHeightValues = { min: [], max: [] };

  function isCycleCollection() {
    return Boolean(document.querySelector('.bike4sport-cycle-collection'));
  }

  function getHeight() {
    const params = new URLSearchParams(window.location.search);
    const height = params.get(HEIGHT_PARAM);
    if (height) return height;

    const legacyMin = params.get(LEGACY_MIN_PARAM);
    const legacyMax = params.get(LEGACY_MAX_PARAM);
    return legacyMin && legacyMin === legacyMax ? legacyMin : '';
  }

  function numberValuesFor(paramName) {
    const values = Array.from(document.querySelectorAll('input[name="' + paramName + '"]'))
      .map(function (input) {
        return Number.parseInt(input.value, 10);
      })
      .filter(Number.isInteger);

    return Array.from(new Set(values)).sort(function (a, b) {
      return a - b;
    });
  }

  function mergeHeightValues(currentValues, newValues) {
    return Array.from(new Set(currentValues.concat(newValues))).sort(function (a, b) {
      return a - b;
    });
  }

  function captureNativeHeightValues() {
    nativeHeightValues.min = mergeHeightValues(
      nativeHeightValues.min,
      numberValuesFor(MIN_PARAM)
    );
    nativeHeightValues.max = mergeHeightValues(
      nativeHeightValues.max,
      numberValuesFor(MAX_PARAM)
    );

    const input = document.querySelector('[data-bike4sport-height-input]');
    if (!input || !nativeHeightValues.min.length || !nativeHeightValues.max.length) {
      return;
    }

    input.min = String(nativeHeightValues.min[0]);
    input.max = String(nativeHeightValues.max[nativeHeightValues.max.length - 1]);
  }

  function syncHeightInput() {
    const input = document.querySelector('[data-bike4sport-height-input]');
    if (input) input.value = getHeight();
  }

  function isHeightParam(paramName) {
    return paramName.includes('min_hoejde') || paramName.includes('max_hoejde');
  }

  function removesOnlyHeightFilter(link) {
    const currentParams = new URLSearchParams(window.location.search);
    const targetParams = new URL(link.href, window.location.origin).searchParams;
    const removedParamNames = new Set();

    currentParams.forEach(function (value, name) {
      if (!targetParams.getAll(name).includes(value)) {
        removedParamNames.add(name);
      }
    });

    const relevantRemovedParamNames = Array.from(removedParamNames).filter(function (name) {
      return name !== 'page' && name !== 'section_id' && name !== HEIGHT_PARAM;
    });

    return (
      relevantRemovedParamNames.length > 0 &&
      relevantRemovedParamNames.every(isHeightParam)
    );
  }

  function isTechnicalHeightFacet(remove, link) {
    if (removesOnlyHeightFilter(link)) return true;

    const label = String(remove.textContent || '')
      .replace(/\s+/g, ' ')
      .trim();

    return (
      label.indexOf('Min. højde (teknisk):') === 0 ||
      label.indexOf('Max. højde (teknisk):') === 0
    );
  }

  function tidyFilters() {
    document.querySelectorAll('[data-filter-param]').forEach(function (filter) {
      const paramName = filter.dataset.filterParam || '';
      const checkboxValues = Array.from(filter.querySelectorAll('input[type="checkbox"]'));
      const hasActiveValue = checkboxValues.some(function (input) {
        return input.checked;
      });

      filter.classList.remove(
        'bike4sport-filter--single-value',
        'bike4sport-filter--technical-height',
        'bike4sport-filter--cycle-noise'
      );

      if (isHeightParam(paramName)) {
        filter.classList.add('bike4sport-filter--technical-height');
      } else if (
        isCycleCollection() &&
        (paramName === 'filter.p.m.custom.cykeltype' ||
          paramName === 'filter.v.t.shopify.color-pattern')
      ) {
        filter.classList.add('bike4sport-filter--cycle-noise');
      } else if (checkboxValues.length === 1 && !hasActiveValue) {
        filter.classList.add('bike4sport-filter--single-value');
      }
    });

    document.querySelectorAll('.active-facets facet-remove').forEach(function (remove) {
      if (remove.dataset.bike4sportHeightBadge === 'true') return;

      const link = remove.querySelector('a[href]');
      if (!link) return;

      if (isTechnicalHeightFacet(remove, link)) {
        remove.classList.add('bike4sport-filter--technical-height');
      } else {
        remove.classList.remove('bike4sport-filter--technical-height');
        preserveHeightStateOnFacetLink(link);
      }
    });

    document.querySelectorAll('.active-facets a.active-facets__button-remove[href]').forEach(function (link) {
      const targetUrl = new URL(link.href, window.location.origin);
      targetUrl.searchParams.delete(HEIGHT_PARAM);
      link.href = targetUrl.toString();
    });
  }

  function isCycleOverview() {
    return Boolean(document.querySelector('[data-bike4sport-cycle-overview="true"]'));
  }

  function updateCycleConditionSwitchers() {
    document.querySelectorAll('[data-bike4sport-condition-switcher]').forEach(function (switcher) {
      const rawBaseUrl = String(switcher.dataset.bike4sportConditionBaseUrl || '').trim();
      const baseUrl = rawBaseUrl.replace(/\/+$/, '');

      if (!baseUrl) return;

      const pathname = window.location.pathname.replace(/\/+$/, '');
      let activeCondition = 'all';

      if (pathname === baseUrl + '/ny') {
        activeCondition = 'ny';
      } else if (pathname === baseUrl + '/brugt') {
        activeCondition = 'brugt';
      }

      switcher.querySelectorAll('[data-bike4sport-condition]').forEach(function (link) {
        const condition = String(link.dataset.bike4sportCondition || 'all');
        const href = baseUrl + (condition === 'all' ? '' : '/' + condition) + window.location.search;
        const isActive = condition === activeCondition;

        link.href = href;
        link.classList.toggle('is-active', isActive);

        if (isActive) {
          link.setAttribute('aria-current', 'page');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    });
  }

  function productTypeValueForInput(input) {
    const directValue = String(input.value || input.getAttribute('value') || '').trim();
    if (directValue) return directValue;

    const label = input.closest('label');
    const labelValue = label && label.querySelector('.facet-checkbox__text-label');

    return String(labelValue ? labelValue.textContent : '').trim();
  }

  function isGravelProductType(value) {
    return GRAVEL_PRODUCT_TYPES.includes(String(value || ''));
  }

  function countForGravelInput(input) {
    const label = input.closest('label');
    const match = String(label ? label.textContent : '').match(/\((\d+)\)/);

    return match ? Number.parseInt(match[1], 10) : 0;
  }

  function updateGravelGroupLabel(listItem, selectedCount, totalCount) {
    const label = listItem.querySelector('label');
    const input = listItem.querySelector('input[type="checkbox"]');
    const visibleLabel = listItem.querySelector('.facet-checkbox__text-label');
    const visibleText = listItem.querySelector('.facet-checkbox__text');
    const accessibleText = listItem.querySelector('.visually-hidden');

    if (!label || !input) return;

    label.classList.toggle('active', selectedCount > 0);
    label.classList.remove('disabled');

    if (visibleLabel) visibleLabel.textContent = 'Gravel / Cross';
    if (visibleText) {
      Array.from(visibleText.childNodes).forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) node.remove();
      });
      visibleText.append(document.createTextNode(' (' + totalCount + ')'));
    }
    if (accessibleText) {
      accessibleText.textContent = 'Gravel / Cross (' + totalCount + ' produkter)';
    }
  }

  function gravelClearSearchParams() {
    const params = new URLSearchParams(window.location.search);
    const retainedProductTypes = params
      .getAll(PRODUCT_TYPE_PARAM)
      .filter(function (value) {
        return !isGravelProductType(value);
      });

    params.delete(PRODUCT_TYPE_PARAM);
    retainedProductTypes.forEach(function (value) {
      params.append(PRODUCT_TYPE_PARAM, value);
    });

    return params;
  }

  function isGravelFacetRemoveLink(link) {
    const currentParams = new URLSearchParams(window.location.search);
    const targetParams = new URL(link.href, window.location.origin).searchParams;
    const currentProductTypes = currentParams.getAll(PRODUCT_TYPE_PARAM);
    const targetProductTypes = targetParams.getAll(PRODUCT_TYPE_PARAM);

    return currentProductTypes.some(function (value) {
      return isGravelProductType(value) && !targetProductTypes.includes(value);
    });
  }

  function updateGravelActiveFacets() {
    const hasSelectedGravel = new URLSearchParams(window.location.search)
      .getAll(PRODUCT_TYPE_PARAM)
      .some(isGravelProductType);

    document.querySelectorAll('.active-facets').forEach(function (container) {
      container
        .querySelectorAll('a[data-bike4sport-gravel-badge="true"]')
        .forEach(function (badge) {
          badge.remove();
        });

      const gravelRemoves = Array.from(container.querySelectorAll('facet-remove')).filter(function (remove) {
        const link = remove.querySelector('a[href]');
        if (!link) return false;

        remove.style.removeProperty('display');
        return isGravelFacetRemoveLink(link);
      });

      if (!hasSelectedGravel || !gravelRemoves.length) return;

      const clearSearchParams = gravelClearSearchParams();
      const badge = document.createElement('a');
      const content = document.createElement('span');
      const iconWrapper = document.createElement('span');
      const visuallyHidden = document.createElement('span');

      badge.dataset.bike4sportGravelBadge = 'true';
      badge.className = 'active-facets__button active-facets__button--light';
      badge.href =
        window.location.pathname +
        (clearSearchParams.toString() ? '?' + clearSearchParams.toString() : '');
      badge.setAttribute('aria-label', 'Fjern filteret Cykeltype: Gravel / Cross');

      content.className = 'active-facets__button-inner button button--tertiary';
      content.appendChild(document.createTextNode('Cykeltype: Gravel / Cross'));

      iconWrapper.className = 'svg-wrapper';
      iconWrapper.innerHTML =
        '<svg aria-hidden="true" focusable="false" class="icon icon-close-small" viewBox="0 0 10 10">' +
        '<path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '</svg>';
      content.appendChild(iconWrapper);

      visuallyHidden.className = 'visually-hidden';
      visuallyHidden.textContent = 'Fjern filter';
      content.appendChild(visuallyHidden);

      badge.appendChild(content);
      badge.addEventListener('click', function (event) {
        event.preventDefault();
        const params = new URL(badge.href, window.location.origin).searchParams;
        renderWithParams(params);
      });

      container.insertBefore(badge, gravelRemoves[0]);
      gravelRemoves.forEach(function (remove) {
        remove.style.display = 'none';
      });
    });
  }

  function groupGravelProductTypes() {
    if (!isCycleOverview()) return;

    document
      .querySelectorAll('[data-filter-param="' + PRODUCT_TYPE_PARAM + '"]')
      .forEach(function (filter, filterIndex) {
        filter.querySelectorAll('[data-bike4sport-gravel-group="true"]').forEach(function (group) {
          group.remove();
        });

        const gravelInputs = Array.from(
          filter.querySelectorAll('input[name="' + PRODUCT_TYPE_PARAM + '"]')
        ).filter(function (input) {
          return isGravelProductType(productTypeValueForInput(input));
        });

        gravelInputs.forEach(function (input) {
          const productTypeValue = productTypeValueForInput(input);
          if (productTypeValue) {
            input.value = productTypeValue;
            input.setAttribute('value', productTypeValue);
          }

          const listItem = input.closest('li');
          if (listItem) listItem.style.removeProperty('display');
        });

        if (!gravelInputs.length) return;

        const firstListItem = gravelInputs[0].closest('li');
        const firstLabel = firstListItem && firstListItem.querySelector('label');
        const firstInput = firstListItem && firstListItem.querySelector('input[type="checkbox"]');
        const selectedProductTypes = new URLSearchParams(window.location.search).getAll(
          PRODUCT_TYPE_PARAM
        );

        if (!firstListItem || !firstLabel || !firstInput || !firstListItem.parentNode) return;

        const groupListItem = firstListItem.cloneNode(true);
        const groupInput = groupListItem.querySelector('input[type="checkbox"]');
        const groupLabel = groupListItem.querySelector('label');
        const selectedCount = gravelInputs.filter(function (input) {
          return input.checked || selectedProductTypes.includes(productTypeValueForInput(input));
        }).length;
        const totalCount = gravelInputs.reduce(function (total, input) {
          return total + countForGravelInput(input);
        }, 0);
        const groupInputId = 'Bike4sport-Gravel-Group-' + filterIndex;

        groupListItem.dataset.bike4sportGravelGroup = 'true';

        if (!groupInput || !groupLabel) return;

        groupInput.id = groupInputId;
        groupInput.removeAttribute('name');
        groupInput.value = '';
        groupInput.checked = selectedCount === gravelInputs.length;
        groupInput.indeterminate = selectedCount > 0 && selectedCount < gravelInputs.length;
        groupInput.disabled = false;
        groupInput.removeAttribute('disabled');
        groupLabel.htmlFor = groupInputId;

        updateGravelGroupLabel(groupListItem, selectedCount, totalCount);

        groupInput.addEventListener('input', function () {
          const shouldSelectGravel = groupInput.checked;

          gravelInputs.forEach(function (input) {
            input.checked = shouldSelectGravel;
          });

          groupInput.indeterminate = false;
        });

        firstListItem.parentNode.insertBefore(groupListItem, firstListItem);

        gravelInputs.forEach(function (input) {
          const listItem = input.closest('li');
          if (listItem) listItem.style.display = 'none';
        });
      });

    updateGravelActiveFacets();
  }


  function preserveHeightStateOnFacetLink(link) {
    const height = getHeight();
    if (!height) return;

    const targetUrl = new URL(link.href, window.location.origin);
    targetUrl.searchParams.set(HEIGHT_PARAM, height);
    link.href = targetUrl.toString();
  }

  function syncHeightStateFields() {
    const height = getHeight();

    document.querySelectorAll('facet-filters-form form').forEach(function (form) {
      let stateInput = form.querySelector('[data-bike4sport-height-state]');

      if (!height) {
        if (stateInput) stateInput.remove();
        return;
      }

      if (!stateInput) {
        stateInput = document.createElement('input');
        stateInput.type = 'hidden';
        stateInput.name = HEIGHT_PARAM;
        stateInput.dataset.bike4sportHeightState = 'true';
        form.appendChild(stateInput);
      }

      stateInput.value = height;
      stateInput.setAttribute('value', height);
    });
  }

  function heightClearUrl() {
    const params = new URLSearchParams(window.location.search);
    params.delete(MIN_PARAM);
    params.delete(MAX_PARAM);
    params.delete(HEIGHT_PARAM);
    params.delete(LEGACY_MIN_PARAM);
    params.delete(LEGACY_MAX_PARAM);
    params.delete(NO_MATCH_PARAM);

    return window.location.pathname + (params.toString() ? '?' + params.toString() : '');
  }

  function finderTypeForCollection() {
    const path = window.location.pathname;
    if (/(racer|landevej)/.test(path)) return 'racer';
    if (/(gravel|cross)/.test(path)) return 'gravel';
    if (/(mountain|mtb)/.test(path)) return 'mtb';
    if (/(el-cykler|elcykler)/.test(path)) return 'el';
    if (/(triathlon|tt-)/.test(path)) return 'tt';
    return '';
  }

  function renderHeightNoMatchState() {
    document.querySelectorAll('[data-bike4sport-height-no-match]').forEach(function (notice) {
      notice.remove();
    });

    const height = Number.parseInt(getHeight(), 10);
    if (!isCycleCollection() || !Number.isInteger(height)) return;

    const grid = document.querySelector('#product-grid');
    const forcedNoMatch = new URLSearchParams(window.location.search).get(NO_MATCH_PARAM) === '1';
    const noProducts = grid && grid.querySelectorAll('.grid__item').length === 0;
    if (!forcedNoMatch && !noProducts) return;

    const container = document.querySelector('#ProductGridContainer') || grid && grid.parentElement;
    if (!container) return;
    const finderParams = new URLSearchParams({ height: String(height) });
    const type = finderTypeForCollection();
    if (type) finderParams.set('type', type);

    const notice = document.createElement('section');
    notice.dataset.bike4sportHeightNoMatch = 'true';
    notice.className = 'bike4sport-height-no-match';
    notice.style.cssText = 'margin:0 0 24px;padding:26px;border:1px solid #cfe4de;border-radius:18px;background:#f7fcfa;color:#073b5c;';
    notice.innerHTML =
      '<h2>Ingen præcis størrelsesmatch her lige nu</h2>' +
      '<p>Vi viser kun cykler, hvor din højde på <strong>' + height + ' cm</strong> ligger inden for producentens anbefalede interval. Se i stedet alle relevante cykler i vores størrelsesguide.</p>' +
      '<a href="/pages/find-din-cykel?' + finderParams.toString() + '">Find cykler i min størrelse <span aria-hidden="true">→</span></a>' +
      '<a class="bike4sport-height-no-match__clear" href="' + heightClearUrl() + '">Fjern højdefilter</a>';
    container.insertBefore(notice, container.firstChild);
    notice.querySelectorAll('a').forEach(function (link, index) {
      link.style.cssText = index === 0
        ? 'display:inline-block;margin:8px 10px 0 0;padding:11px 16px;border-radius:999px;background:#15937f;color:#fff;font-weight:700;text-decoration:none;'
        : 'display:inline-block;margin-top:8px;color:#0f7765;font-weight:700;';
    });
    if (forcedNoMatch && grid) grid.hidden = true;
  }

  function renderHeightBadges() {
    document
      .querySelectorAll('[data-bike4sport-height-badge]')
      .forEach(function (badge) {
        badge.remove();
      });

    const height = getHeight();
    if (!height || !isCycleCollection()) return;

    document.querySelectorAll('.active-facets').forEach(function (container) {
      const link = document.createElement('a');
      link.dataset.bike4sportHeightBadge = 'true';
      link.href = heightClearUrl();
      link.className = 'active-facets__button active-facets__button--light';
      link.setAttribute('aria-label', 'Fjern højdefilter på ' + height + ' cm');

      const content = document.createElement('span');
      content.className = 'active-facets__button-inner button button--tertiary';
      content.appendChild(document.createTextNode('Højde: ' + height + ' cm'));

      const iconWrapper = document.createElement('span');
      iconWrapper.className = 'svg-wrapper';
      iconWrapper.innerHTML =
        '<svg aria-hidden="true" focusable="false" class="icon icon-close-small" viewBox="0 0 10 10">' +
        '<path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
        '</svg>';
      content.appendChild(iconWrapper);

      const visuallyHidden = document.createElement('span');
      visuallyHidden.className = 'visually-hidden';
      visuallyHidden.textContent = 'Fjern filter';
      content.appendChild(visuallyHidden);

      link.appendChild(content);
      link.addEventListener('click', function (event) {
        event.preventDefault();
        const params = new URL(link.href, window.location.origin).searchParams;
        renderWithParams(params);
      });
      container.prepend(link);
    });
  }

  function refresh() {
    captureNativeHeightValues();
    syncHeightInput();
    syncHeightStateFields();
    tidyFilters();
    updateCycleConditionSwitchers();
    groupGravelProductTypes();
    renderHeightBadges();
    renderHeightNoMatchState();
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      bindHeightInput();
      refresh();
    }, 175);
  }

  function renderWithParams(params) {
    const searchParams = params.toString();
    const facetForm = window.customElements.get('facet-filters-form');

    if (facetForm && typeof facetForm.renderPage === 'function') {
      facetForm.renderPage(searchParams, null, true);
      scheduleRefresh();
      return;
    }

    window.location.assign(
      window.location.pathname + (searchParams ? '?' + searchParams : '')
    );
  }

  function setHeight(rawValue) {
    const value = String(rawValue || '').trim();
    const params = new URLSearchParams(window.location.search);
    const height = Number.parseInt(value, 10);

    params.delete(MIN_PARAM);
    params.delete(MAX_PARAM);
    params.delete(LEGACY_MIN_PARAM);
    params.delete(LEGACY_MAX_PARAM);
    params.delete('page');
    params.delete(NO_MATCH_PARAM);

    if (value === '') {
      params.delete(HEIGHT_PARAM);
      renderWithParams(params);
      return;
    }

    if (!Number.isInteger(height) || height < MIN_HEIGHT || height > MAX_HEIGHT) {
      return;
    }

    if (window.Bike4SportSizeProfile) {
      window.Bike4SportSizeProfile.save(height);
    }

    captureNativeHeightValues();
    const matchingMinimums = nativeHeightValues.min.filter(function (minimum) {
      return minimum <= height;
    });
    const matchingMaximums = nativeHeightValues.max.filter(function (maximum) {
      return maximum >= height;
    });

    if (!matchingMinimums.length || !matchingMaximums.length) {
      params.set(HEIGHT_PARAM, String(height));
      params.set(NO_MATCH_PARAM, '1');
      renderWithParams(params);
      return;
    }

    params.set(HEIGHT_PARAM, String(height));
    matchingMinimums.forEach(function (minimum) {
      params.append(MIN_PARAM, String(minimum));
    });
    matchingMaximums.forEach(function (maximum) {
      params.append(MAX_PARAM, String(maximum));
    });

    renderWithParams(params);
  }

  function clearHeight() {
    setHeight('');
  }

  function bindHeightInput() {
    const input = document.querySelector('[data-bike4sport-height-input]');
    if (!input || input.dataset.bike4sportHeightBound === 'true') return;

    input.dataset.bike4sportHeightBound = 'true';
    input.addEventListener('input', function () {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(function () {
        setHeight(input.value.trim());
      }, 350);
    });
  }

  function migrateHeightFilter() {
    const params = new URLSearchParams(window.location.search);
    const height = getHeight();

    if (!height) return false;

    const hasNativeSelection =
      params.getAll(MIN_PARAM).length > 0 && params.getAll(MAX_PARAM).length > 0;
    const hasCurrentState = params.get(HEIGHT_PARAM) === height;
    const hasLegacyState =
      params.has(LEGACY_MIN_PARAM) || params.has(LEGACY_MAX_PARAM);

    if (hasNativeSelection && hasCurrentState && !hasLegacyState) {
      return false;
    }

    setHeight(height);
    return true;
  }

  function keepHeightStateDuringFacetInput(event) {
    const form = event.target.closest('form');
    const height = getHeight();

    if (!form || !form.closest('facet-filters-form') || !height) return;

    let stateInput = form.querySelector('[data-bike4sport-height-state]');
    if (!stateInput) {
      stateInput = document.createElement('input');
      stateInput.type = 'hidden';
      stateInput.name = HEIGHT_PARAM;
      stateInput.dataset.bike4sportHeightState = 'true';
      form.appendChild(stateInput);
    }

    stateInput.value = height;
    stateInput.setAttribute('value', height);
  }

  function watchFacetUpdates() {
    document.addEventListener('input', keepHeightStateDuringFacetInput, true);
    document.addEventListener('change', keepHeightStateDuringFacetInput, true);

    const originalFetch = window.fetch.bind(window);

    window.fetch = function () {
      const request = arguments[0];
      const requestUrl =
        typeof request === 'string' ? request : request && request.url;

      return originalFetch.apply(window, arguments).then(function (response) {
        const responseUrl = response && response.url ? response.url : '';
        if (
          String(requestUrl || '').includes('section_id=') ||
          String(requestUrl || '').includes('sections=') ||
          String(responseUrl).includes('section_id=') ||
          String(responseUrl).includes('sections=')
        ) {
          scheduleRefresh();
        }
        return response;
      });
    };

    const observedRoot = document.body;
    if (observedRoot && typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver(function (mutations) {
        const selector =
          '.js-filter, .active-facets, facet-remove, .active-facets__button-remove, #main-collection-filters, #ProductGridContainer, [data-filter-param]';

        const filtersWereReplaced = mutations.some(function (mutation) {
          return Array.from(mutation.addedNodes).some(function (node) {
            if (node.nodeType !== Node.ELEMENT_NODE) return false;

            return (
              node.matches(selector) ||
              Boolean(node.querySelector(selector))
            );
          });
        });

        if (filtersWereReplaced) scheduleRefresh();
      });

      observer.observe(observedRoot, { childList: true, subtree: true });
    }

    window.addEventListener('popstate', function () {
      window.setTimeout(refresh, 50);
    });
  }

  function initialise() {
    bindHeightInput();
    captureNativeHeightValues();
    watchFacetUpdates();

    if (!migrateHeightFilter()) {
      refresh();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
})();
